import { render, staticRenderFns } from "./registerbusiness.vue?vue&type=template&id=8b44a5b6&scoped=true"
import script from "./registerbusiness.vue?vue&type=script&lang=js"
export * from "./registerbusiness.vue?vue&type=script&lang=js"
import style0 from "./registerbusiness.vue?vue&type=style&index=0&id=8b44a5b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b44a5b6",
  null
  
)

export default component.exports